import {useState, useEffect} from 'react';

export default ({time}) => {
    const [timer, setTimer] = useState(time - Date.now());

    const format = time => {
        let hours = Math.floor(time / (60 * 60 * 1e3));
        time -= hours * (60 * 60 * 1e3);

        let minutes = Math.floor(time / (60 * 1e3));
        time -= minutes * (60 * 1e3);

        let seconds = Math.floor(time / 1e3);

        return `${hours > 0 ? `${hours}h` : ''} ${minutes > 0 ? `${minutes}m` : ''} ${seconds > 0 ? `${seconds}s` : ''}`.trim();
    }

    const _time = (12 * 60 * 60 * 1e3);

    useEffect(() => {
        if(timer > 0)
            window.facebookTimerTimeout = setTimeout(() => {
                setTimer(time - Date.now())
            }, 1e3);

        return () => clearTimeout(window.facebookTimerTimeout)
    }, [timer]);

    if(timer < 0)
        return <></>;

    return (
        <div className="facebook-bonus">
            <div className="top">
                <div className="left">
                    <div className="icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.16689 5.16672H8.00023C7.92173 5.16352 7.84506 5.14212 7.77626 5.1042C7.70746 5.06628 7.64842 5.01288 7.6038 4.94822C7.55918 4.88356 7.53022 4.80941 7.51918 4.73163C7.50815 4.65385 7.51535 4.57457 7.54023 4.50005C7.77356 3.91338 7.98689 3.31338 8.16023 2.72672C8.30689 2.27338 8.88023 0.853384 10.3202 0.853384C10.8814 0.8354 11.4269 1.0408 11.8368 1.4245C12.2468 1.8082 12.4878 2.33887 12.5069 2.90005C12.5069 4.18672 11.0469 4.71338 10.5069 4.90005C9.74345 5.09927 8.95558 5.18905 8.16689 5.16672ZM10.3136 1.83338C9.54689 1.83338 9.20023 2.72005 9.11356 2.99338C8.99356 3.38005 8.86689 3.76672 8.72689 4.15338C9.20484 4.15035 9.68021 4.08308 10.1402 3.95338C10.5202 3.82005 11.4736 3.46005 11.4736 2.88005C11.453 2.58947 11.3207 2.31813 11.1045 2.12298C10.8882 1.92783 10.6047 1.82404 10.3136 1.83338Z" fill="#0C76DA"/>
                            <path d="M7.81352 5.16675C7.04198 5.18034 6.27232 5.0861 5.52686 4.88675C3.86686 4.34675 3.52686 3.50009 3.52686 2.88675C3.52964 2.6277 3.58483 2.37189 3.68909 2.13473C3.79335 1.89756 3.94453 1.68395 4.13352 1.50675C4.55379 1.08397 5.12407 0.844352 5.72019 0.840088C6.84019 0.840088 7.40686 1.88675 7.82686 2.63342C8.0998 3.24551 8.32275 3.87869 8.49352 4.52675C8.51417 4.6003 8.5177 4.67759 8.50383 4.75271C8.48997 4.82783 8.45907 4.89877 8.41352 4.96009C8.36936 5.02201 8.31148 5.07288 8.24441 5.10874C8.17733 5.14459 8.10288 5.16444 8.02685 5.16675H7.81352ZM5.64686 1.83342C5.33027 1.84706 5.03141 1.98334 4.81352 2.21342C4.71849 2.29722 4.64166 2.39962 4.58777 2.51428C4.53387 2.62895 4.50407 2.75345 4.50019 2.88009C4.50019 3.28675 4.99352 3.68009 5.83352 3.95342C6.32367 4.08011 6.8273 4.14727 7.33352 4.15342C7.22569 3.79839 7.09429 3.45095 6.94019 3.11342C6.55352 2.37342 6.18019 1.84675 5.66686 1.83342H5.64686Z" fill="#0C76DA"/>
                            <path d="M14.1668 6.83341V6.00008C14.1668 5.51385 13.9737 5.04754 13.6299 4.70372C13.286 4.3599 12.8197 4.16675 12.3335 4.16675H3.66683C3.1806 4.16675 2.71428 4.3599 2.37047 4.70372C2.02665 5.04754 1.8335 5.51385 1.8335 6.00008V6.83341H14.1668ZM8.50016 7.83341V15.1667H12.3335C12.8197 15.1667 13.286 14.9736 13.6299 14.6298C13.9737 14.286 14.1668 13.8196 14.1668 13.3334V7.83341H8.50016ZM7.50016 7.83341H1.8335V13.3334C1.8335 13.8196 2.02665 14.286 2.37047 14.6298C2.71428 14.9736 3.1806 15.1667 3.66683 15.1667H7.50016V7.83341Z" fill="#0C76DA"/>
                        </svg>
                    </div>
                </div>
                <div className="right">
                    <div className="title">Active bonus</div>
                    <div className="text">You have a bonus for +5% deposit and +5% referral payout for completing tasks</div>
                </div>
            </div>
            <div className="timer-info">
                <div className="progress">
                    <div className="line">
                        <div className="line-value" style={{width: ((timer / (24 * 60 * 60 * 1e3))*100) + '%'}}></div>
                    </div>
                    <div className="progress-text">{format(timer)}</div>
                </div>
            </div>
        </div>       
    )
}